import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepChooseStationNvidiaShuttle,
  StepErrorNvidiaShuttle,
  StepFinishedNvidiaShuttle,
  StepLoginNvidiaShuttle,
  StepVerifyCodeNvidiaShuttle,
} from "../../steps-nvidiashuttle";

export const NvidiaShuttleLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        >
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.NvidiashuttleLogoPNG}
            alt="Nvidia Shuttle logo"
            width="206"
            height="117"
          />
        </button>
        {(!step || step === LandingStepEnum.LoginStep) && (
          <StepLoginNvidiaShuttle />
        )}
        {step === LandingStepEnum.VerificationStep && (
          <StepVerifyCodeNvidiaShuttle />
        )}
        {step === LandingStepEnum.ChooseStationStep && (
          <StepChooseStationNvidiaShuttle />
        )}
        {step === LandingStepEnum.FinishedStep && <StepFinishedNvidiaShuttle />}
        {step === LandingStepEnum.ErrorStep && <StepErrorNvidiaShuttle />}
      </div>
    </main>
  );
};
